export const handleChange = (e: any, process: any) => {
  const { name, value } = e.target;
  process[name] = value;
};
